<template>
    <div id="app">
        <router-view :key="$route.fullPath"></router-view>
    </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import Echo from "laravel-echo";

export default {
    computed: {
        authUser() {
            return this.$store.getters["auth/user"];
        },
    },

    watch: {
        authUser(val) {
            if (val) {
                this.initWebsocket();
                this.userPing();
            }
        },
    },

    mounted() {
        const language = this.$cookies.get("lang");
        if (language) {
            window.lang.setLocale(language);
        }
    },

    updated() {
        if (this.$tours) {
            for (const [key, value] of Object.entries(this.$tours)) {
                value.finish();
            }
        }
    },

    methods: {
        initWebsocket() {
            window.Echo = new Echo({
                broadcaster: "pusher",
                key: process.env.MIX_PUSHER_APP_KEY,
                cluster: process.env.MIX_PUSHER_APP_CLUSTER,
                encrypted: true,
                auth: {
                    headers: {
                        Authorization:
                            "Bearer " + localStorage.getItem("access_token"),
                    },
                },
            });
        },

        userPing() {
            if (!this.authUser) return;

            let ping;

            if (!this.authUser) {
                clearTimeout(ping);
                return;
            }

            axios
                .post("/users/ping")
                .then(() => {
                    ping = setTimeout(() => {
                        this.userPing();
                    }, 300000);
                })
                .catch(() => {
                    ping = setTimeout(() => {
                        this.userPing();
                    }, 300000);
                });
        },
    },
};
</script>

<style lang="scss">
@import "./../../css/main.css";
button:not(.v-btn--is-elevated) {
    &.text-none {
        border: 1px solid rgba(0, 0, 0, 0.87);
    }
}
.v-input__append-inner {
    margin: auto !important;
}
.cannot-edit {
    input,
    .v-input,
    button,
    .cursor-pointer,
    .v-data-table {
        pointer-events: none !important;
    }
}
.vue-tel-input {
    border: none !important;
    box-shadow: none !important;
    input {
        display: block;
        width: 100%;
        height: 40px;
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        color: var(--v-spantitle);
        background-color: var(--d-background);
        background-clip: padding-box;
        border: 1px solid var(--border-color-darker);
        border-radius: 0.3rem;
    }
    &.is-invalid {
        border: 1px solid #ff5c75 !important;
        border-radius: 0.3rem !important;
    }
}
</style>
